import { render, staticRenderFns } from "./SalesOrderViewDetailsSalesOrderItemForm.vue?vue&type=template&id=1c725008&"
import script from "./SalesOrderViewDetailsSalesOrderItemForm.vue?vue&type=script&lang=js&"
export * from "./SalesOrderViewDetailsSalesOrderItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports